import "core-js/modules/es.array.concat";
export var wrapDecorator = function wrapDecorator(targetDecorator) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] !== 'function' && typeof args[1] !== 'string') {
      return function (target, key, descorator) {
        return targetDecorator.apply(void 0, [target, key, descorator].concat(args));
      };
    }

    return targetDecorator.apply(void 0, args);
  };
};